import type { CSSProperties } from 'react'
import { FiChevronDown } from 'react-icons/fi'
import {
  CONTRACT_CURRENCY_OPTIONS,
  DEFAULT_CONTRACT_CURRENCY,
} from '@/constants/contractCurrencies'

interface ContractPriceInputProps {
  price: string
  currency: string
  onPriceChange: (price: string) => void
  onCurrencyChange: (currency: string) => void
}

const fieldStyle: CSSProperties = {
  fontFamily: 'Lexend Deca',
  fontSize: '12px',
  height: '40px',
  border: '1px solid #E9E9EA',
  borderRadius: '8px',
}

const labelStyle: CSSProperties = {
  fontFamily: 'Lexend Deca',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '22px',
  color: '#69697A',
  display: 'block',
  marginBottom: '8px',
}

const ContractPriceInput = ({
  price,
  currency,
  onPriceChange,
  onCurrencyChange,
}: ContractPriceInputProps) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label style={labelStyle}>Price</label>
        <input
          type="text"
          inputMode="decimal"
          value={price}
          onChange={(e) => onPriceChange(e.target.value)}
          placeholder="Enter price"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
          style={fieldStyle}
        />
      </div>
      <div>
        <label style={labelStyle}>Currency</label>
        <div className="relative">
          <select
            value={currency || DEFAULT_CONTRACT_CURRENCY}
            onChange={(e) => onCurrencyChange(e.target.value)}
            className="w-full px-4 py-2 pr-8 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 appearance-none"
            style={{ ...fieldStyle, color: '#212126', fontWeight: 500 }}
          >
            {CONTRACT_CURRENCY_OPTIONS.map((option) => (
              <option key={option.code} value={option.code}>
                {option.label} ({option.symbol})
              </option>
            ))}
          </select>
          <FiChevronDown
            className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
            style={{ width: 16, height: 16, color: '#212126', opacity: 0.8 }}
          />
        </div>
      </div>
    </div>
  )
}

export default ContractPriceInput
